class SiteElementPopup
    extends QueryElement<HTMLElement> {
    
    private readonly _site: Site;
    private _container: QueryElement<HTMLElement>;
    private _close: QueryElement<HTMLElement>;
    private _containerInner: QueryElement<HTMLElement>;

    private _closeClick: (e: Event) => any;
    
    constructor(site: Site) {
        super(document.createElement("DIV"));
        
        this._site = site;

        // Disable overflow of body
        document.body.style.overflow = "hidden";

        this.addClass("element-popup");
        this.on("click", e => {
            if (e.target == this.get()) {
                this._site.closePopup();
            }
        });

        this._container = QueryElement.QueryElement("div")
            .appendTo(this);
        
        this._containerInner = QueryElement.QueryElement("div")
            .addClass("popup")
            .appendTo(this._container);
        
        this._close = QueryElement.QueryElement("i")
            .addClass("close")
            .setText("clear")
            .appendTo(this._container);
        
        this._closeClick = this._close.on("click", e => {
            this._site.closePopup();
        });
    }
    async request(url: string) {
        let request = new QueryRequest(url, {
            method: 'get'
        });
        
        let response = await request.request();
        this._containerInner.setHtml(await response.text());

        this._containerInner.query(".element-image").createAll<SiteElementImage, HTMLElement>(a => new SiteElementImage(a));
        this._containerInner.query(".element-favorite").createAll<SiteElementFavorite, HTMLElement>(a => new SiteElementFavorite(a, this._site));
        this._containerInner.query(".element-buy").createAll<SiteElementBuy, HTMLElement>(a => new SiteElementBuy(a, this._site));
        this._containerInner.query(".element-product-navigation").createAll<SiteElementProductNavigation, HTMLElement>(a => new SiteElementProductNavigation(a, this._site as SiteAssortment, url));
        this._containerInner.query(".display-product").createAll<SiteElementProductStaticContainer, HTMLElement>(a => new SiteElementProductStaticContainer(a, this._site));
        this._containerInner.query(".bind").createAll<SiteBind, HTMLElement>(a => new SiteBind(a));
    }
    
    async remove(removeInner = true) {
        this._close.off("click", this._closeClick);

        // Enable overflow of body
        document.body.style.overflow = "visible";
        
        await super.remove(removeInner);
    }
}